import { render, staticRenderFns } from "./TheDetail.vue?vue&type=template&id=5a8c17c4&"
import script from "./TheDetail.vue?vue&type=script&lang=js&"
export * from "./TheDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports